import { useNotification } from "@refinedev/core";
import { Select } from "antd";
import React from "react";
import { isValidEmail } from "../lib/imo-parsing";

interface RecipientsInputProps {
  value: string[];
  onChange: (value: string[]) => void;
}

// The toast names the refused entry as typed (fix round 1, 2026-10-30), so a
// pasted list says which address to fix. The email report form keeps its one
// field message under the field.
const refusedRecipientText = (entry: string): string =>
  `${entry} is not a valid email address. Use the form name@company.com.`;

// antd tags-mode Select used as an inline recipient-email picker. Every new
// tag is validated before it is allowed into `value` - invalid entries never
// make it into the list, they just surface an error notification instead,
// one per refused entry.
export const RecipientsInput: React.FC<RecipientsInputProps> = ({
  value,
  onChange,
}) => {
  const { open: notify } = useNotification();

  const handleChange = (next: string[]) => {
    const addedEntries = next.filter((entry) => !value.includes(entry));
    const invalidEntries = addedEntries.filter((entry) => !isValidEmail(entry));

    invalidEntries.forEach((entry) =>
      notify?.({
        type: "error",
        message: "Invalid recipient",
        description: refusedRecipientText(entry),
      })
    );

    onChange(
      next.filter((entry) => value.includes(entry) || isValidEmail(entry))
    );
  };

  return (
    <Select
      mode="tags"
      style={{ minWidth: 240, width: "100%" }}
      tokenSeparators={[",", " "]}
      open={false}
      value={value}
      onChange={handleChange}
      placeholder="Add recipient email"
    />
  );
};
